//  FullPage
class _FullPage {
  constructor () {
    this.default = {
      menu: '#fullpage_menu',
      anchors: ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth'],
      lockAnchors: false,
      navigation: false,
      
      css3: true,
      scrollingSpeed: 500,
      scrollBar: false,
      easingcss3: 'ease-in-out',
      offsetSections: false,  //  是否显示半屏数据, 可以用来显示Footer
      normalScrollElements: '#page---num',  //  此功能可以让某页使用原生滚动
      scrollOverflow: true,  //  滚动内容
      scrollOverflowReset: false,
      touchSensitivity: 20,
      scrollOverflowOptions: {
        // click: false,
        snap: true,
        snapStepY: 34,
        bounce: false,
        interactiveScrollbars: true,
        // disableMouse: true,
        // disablePointer: true,
        // disableTouch: true
      },
      //https://codepen.io/Buff_/pen/oGYyvV
      //Accessibility
      keyboardScrolling: false,
      animateAnchor: true,
      recordHistory: true,
      
      //  nanoScroller 滚动条元素不触发fullpage
      // normalScrollElements: '.nano,#mainMenuTable,.process-num-box,.footerProcessBar,.lh-f-p-3-slick,.picture-slider-for',
      normalScrollElements: '.nano,#mainMenuTable,.process-num-box,.footerProcessBar',
      normalScrollElementTouchThreshold: 3,
      
      verticalCentered: false,  //  是否让内容居中
      sectionsColor: [], //  为每个section设置背景色
      paddingTop: '0', //设置每一个section的顶部和底部的padding，默认为0；一般如果我们需要设置一个固定在顶部或者底部的菜单、导航、元素等，可以使用这两个配置项。
      paddingBottom: '0',
      responsiveWidth: 0, //  每当浏览器的宽度小于0时，插件将像正常网站一样滚动。
      responsiveHeight: 0,
      
      //Custom selectors
      sectionSelector: '.section',
      slideSelector: '.slide',
      
      lazyLoading: true,  //  data-src
      
      //  切换前
      onLeave: (index, nextIndex, direction) => {
        $(window).trigger($.Event('G2_onLeave', {
          index: index,
          nextIndex: nextIndex,
          direction: direction
        }))
      },
      //  切换后
      afterLoad: (anchorLink, index) => {
        $(window).trigger($.Event('G2_afterLoad', {
          anchorLink: anchorLink,
          index: index
        }))
        
        window.setTimeout(() => {
          $.fn.fullpage.reBuild()
        }, 200)
      },
      //  init 事件
      afterRender: () => {
        window.__fullPageInitEd = true
        $(window).trigger($.Event('G2_afterRender'))
      },
      afterResize: () => $(window).trigger($.Event('G2_afterResize')),
      afterResponsive: isResponsive => $(window).trigger($.Event('G2_afterResponsive', {
        isResponsive: isResponsive
      })),
      afterSlideLoad: (anchorLink, index, slideAnchor, slideIndex) => {
        $(window).trigger($.Event('G2_afterSlideLoad', {
          anchorLink: anchorLink,
          index: index,
          slideAnchor: slideAnchor,
          slideIndex: slideIndex
        }))
      },
      onSlideLeave: (anchorLink, index, slideIndex, direction, nextSlideIndex) => {
        $(window).trigger($.Event('G2_afterSlideLoad', {
          anchorLink: anchorLink,
          index: index,
          slideIndex: slideIndex,
          direction: direction,
          nextSlideIndex: nextSlideIndex
        }))
      }
    }
    this.init()
  }
  
  init () {
    //  调用fullpage
    $('#g2-f-p').fullpage(this.default)
    
    /* !! BUG !!
    	getPaddings not defined
    	@author - Buff
    	@date   - 3/5/2018
    	@time   - 9:25 PM
    */
    window.getPaddings = function (element) {
      var section = element.closest('.fp-section');
      if (section.length) {
        return parseInt(section.css('padding-bottom')) + ~~(section.css('padding-top'));
      }
      return 0;
    }
    
    $(window).resize(function () {
      window.setTimeout(function () {
        $.fn.fullpage.reBuild()
      }, 400)
    })
    
  }
}

export default _FullPage